module.exports = "<div class=\"text-center cat__pages__login\">\n    <div class=\"w-50 d-inline-block pt-5 pb-5 mt-5 mb-5\">\n        <h1 class=\"mb-4\"><strong>Error 404</strong></h1>\n        <p class=\"mb-4\">The page you are looking for does not exist; it may have been moved, or removed altogether.\n            You might want to try the search function. Alternatively, return to the front page.\n        </p>\n        <a href=\"javascript: history.back();\" class=\"btn btn-link\">Go Back</a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/pages/page-404.html
// module id = ../../../../../src/app/pages/page-404.html
// module chunks = main